import { describeBatch } from './describeTask';
import { isEditable } from './editWindow';
import TaskRow from './TaskRow';
import type { Batch } from '../BatchTracking/types';

type BatchCardProps = { batch: Batch; now: Date; onEdit: () => void };

// Opens for a change while its creator still may; after that it is the same card with nothing to press.
const BatchCard = ({ batch, now, onEdit }: BatchCardProps) => (
  <TaskRow description={describeBatch(batch)} onOpen={isEditable(batch, now) ? onEdit : undefined} />
);

export default BatchCard;
